/** @jsx jsx */
import { useTheme } from "@cd2/theme/build/es6"
import { css, jsx } from "@emotion/core"
import { Logo } from "./Logo"

export function RotaWrapper({ children }: { children: React.ReactNode }) {
  const { themeColor } = useTheme()

  return (
    <div
      css={css`
        background-color: ${themeColor("primary")};
        margin: 0 auto;
        min-height: 100vh;
        padding: 0 px 64px;
      `}
    >
      <div
        css={css`
          padding: 3vh 0 2vh;
        `}
      >
        <Logo height={75} vertical />
      </div>
      <div
        css={css`
          width: 100%;
          height: 100%;
          background-color: ${themeColor("white")};
        `}
      >
        {children}
      </div>
    </div>
  )
}
